/* eslint-disable no-useless-constructor */
// eslint-disable-next-line max-classes-per-file
import { CONCEPTS } from '@rover/rsdk/src/concepts';
import type { ConsentPurpose } from '@rover/rsdk/src/modules/Analytics';
import { AnalyticsEvent } from '@rover/types/src/Analytics';

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when a user expands an FAQ accordion item within a `FaqSection`.
 * `faqId` is the `FrequentlyAskedQuestion` model id
 *
 * &nbsp;
 */
export class FaqAccordionExpanded extends AnalyticsEvent {
  eventName = 'faq-accordion-expanded';

  consentPurpose: ConsentPurpose = 'performance';

  concept = CONCEPTS.marketing.growth;

  constructor(eventProperties: { faqId?: number }) {
    super(eventProperties);
  }
}

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when a user collapses an FAQ accordion item within a `FaqSection`.
 * `faqId` is the `FrequentlyAskedQuestion` model id
 *
 * &nbsp;
 */
export class FaqAccordionCollapsed extends AnalyticsEvent {
  eventName = 'faq-accordion-collapsed';

  consentPurpose: ConsentPurpose = 'performance';

  concept = CONCEPTS.marketing.growth;

  constructor(eventProperties: { faqId?: number }) {
    super(eventProperties);
  }
}
